export function stringCroppedView(string, length = 30) {
  if (!string) return
  return string.length > length
    ? string.substring(0, length) + '...'
    : string
}